export default function warn(values) {
  const warnings = {}
  if (!values.email_address) {
    warnings.email_address =
      'Enter one or more email addresses separated by a comma.'
  }

  return warnings
}
